module.exports = __webpack_public_path__ + "img/logo1.49ddf4e7.png";